export const LOCAL_STORAGE_KEYS = {
  LOAN_DRILLDOWN: {
    SHOW_TREE_MAP: "app.loanDrilldown.showTreeMap",
  },
};
